import { ref } from "vue";
import { Log } from "./Log";
import { $BTSTracker, BTSTracker } from "./BTSTracker";

export class Settings {
  /* SCAN */
  saveScansLocally = true;
  improveAccuracy = true;

  /* PERFORMANCE */
  animations = true;
  blur = true;

  /* OTHER */
  country = "";

  constructor() {
    if (localStorage) {
      // local storage
      console.log(localStorage);

      const settingsString = localStorage.getItem("settings");
      if (settingsString) {
        const s = JSON.parse(settingsString);
        // iterate s keys
        for (const key in s) {
          if (Reflect.has(this, key)) { // check if key is in this class
            Reflect.set(this, key, s[key]); // update this class instance value at key which is the variable name
          }
        }

      } else { // no settings - init default
        localStorage.setItem("settings", JSON.stringify(this));
      }

      const tableAvailableCell = localStorage.getItem("tableavailablecell");
      if (tableAvailableCell) {
        $BTSTracker.value.colonneDis = JSON.parse(tableAvailableCell);
        console.log($BTSTracker.value.colonneDis); // ['id', 'freq', 'band']
      }

      const table2gActive = localStorage.getItem("table2gactive");
      if (table2gActive) {
        $BTSTracker.value.colonneActive = JSON.parse(table2gActive);
        console.log($BTSTracker.value.colonneActive); 
      }

      const tableWifi = localStorage.getItem("tablewifi");
      if (tableWifi) {
        $BTSTracker.value.colonneWifi = JSON.parse(tableWifi);
        console.log($BTSTracker.value.colonneWifi); 
      }

      const tableBlue = localStorage.getItem("tableblue");
      if (tableBlue) {
        $BTSTracker.value.colonneBlue = JSON.parse(tableBlue);
        console.log($BTSTracker.value.colonneBlue); 
      }

    } else {
      Log.error("localStorage not available");
    }
  }
}

export const settings = new Proxy(new Settings(), // proxy for automatically saving settings
  {
    get(target, prop, receiver) {
      Log.debug("Reading value of " + prop.toString());
      return Reflect.get(target, prop); // just return value
    },
    set(obj, prop, value) {
      Reflect.set(obj, prop, value); // set the variable
      Promise.resolve(localStorage.setItem("settings", JSON.stringify(obj))); // save the settings to localStorage
      Log.info("Settings updated");
      return true;
    }
  }
);

export const settingsRef = ref(settings)